import {
  DistroComponent,
} from "@aidkitorg/types/lib/translation/questions";
import { buildPathMap } from "../ConfigSearch";

/**
 *  Returns a map: targetField -> tree path to be used for scrolling to the component
 *  via findAndGoToComponent in ConfigSearch.tsx
 */
export function buildTargetFieldPathMap(
  components: DistroComponent[],
  map: Record<string, string[]> = {}
): Record<string, string[]> {
  return buildPathMap({
    components,
    map,
    handlePotentialTarget: (component, tree, map) => {
      if (component.kind !== 'Show Field' && ((component as any).targetField || (component as any).targetPrefix)) {
        map[(component as any).targetField || (component as any).targetPrefix] = tree;
      };
    },
  });
}
